<div class="container mb-5 wrapper-content retailer-order-view">
  <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>

  <section class="order-hero">
    <div class="order-hero__cover"></div>
    <div class="order-hero__content">
      <div class="order-hero__left">
        <p class="order-hero__eyebrow">Retailer Order</p>
        <h1 class="order-hero__title">Order {{orderDataDetials?.orderId}}</h1>
        <div class="order-pill-group">
          <span class="order-pill">
            <label>Placed On</label>
            <strong>{{orderDataDetials?.createdAt | date : 'mediumDate'}}</strong>
          </span>
          <span class="order-pill" *ngIf="viewOrderData?.length">
            <label>Items</label>
            <strong>{{viewOrderData.length}}</strong>
          </span>
          <span class="order-pill" *ngIf="orderDataDetials?.myOrderPrice">
            <label>Order Value</label>
            <strong>{{getPrice(orderDataDetials?.myOrderPrice | currency:"ZAR":"R")}}</strong>
          </span>
        </div>
      </div>
      <div class="order-hero__right" *ngIf="orderDataDetials?.returnRequests?.length && loggedInUserType == 'RETAILER'">
        <button class="btn btn-maroon" (click)="openReturnRequestPopup()">
          Check Return Request ({{orderDataDetials.returnRequests.length}})
        </button>
      </div>
    </div>
  </section>

  <section class="order-grid">
    <!-- Product Details -->
    <article class="order-card product-card">
      <div class="section-header">
        <p class="section-eyebrow">Products</p>
        <h2>Items in this order</h2>
      </div>

      <div class="product-list" *ngIf="viewOrderData?.length; else noProduct">
        <div class="product-item" *ngFor="let item of viewOrderData">
          <div class="product-thumb">
            <img [src]="item?.productId?.thumbnail" alt="{{item?.productId?.productName}}">
          </div>
          <div class="product-info">
            <div class="product-head">
              <h3>{{item?.productId?.productName}}</h3>
              <span class="price-chip">{{getPrice((item?.price) | currency:"ZAR":"R")}}</span>
            </div>

            <div class="product-meta-grid">
              <div class="meta-item">
                <span class="meta-label">Quantity</span>
                <span class="meta-value">{{item?.quantity}}</span>
              </div>
              <div class="meta-item">
                <span class="meta-label">Value / Size</span>
                <span class="meta-value">
                  {{item?.priceSizeDetails?.value}}
                  <span *ngIf="item?.priceSizeDetails?.unit">- {{item?.priceSizeDetails?.unit}}</span>
                </span>
              </div>
              <div class="meta-item">
                <span class="meta-label">Product ID</span>
                <span class="meta-value">{{item?._id}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noProduct>
        <div class="empty-state">
          <p>No product details available.</p>
        </div>
      </ng-template>
    </article>

    <!-- Shipping Details -->
    <article class="order-card shipping-card">
      <div class="section-header">
        <p class="section-eyebrow">Deliver To</p>
        <h2>Shipping Address</h2>
      </div>

      <div class="shipping-details">
        <h3>{{orderDataDetials?.shippingAddress?.firstName}} {{orderDataDetials?.shippingAddress?.lastName}}</h3>
        <p class="text-muted">{{orderDataDetials?.shippingAddress?.email}}</p>

        <div class="detail-block">
          <label>Address</label>
          <p>
            {{orderDataDetials?.shippingAddress?.address}}
            {{orderDataDetials?.shippingAddress?.addressLine1}}
            {{orderDataDetials?.shippingAddress?.addressLine2}}
          </p>
          <p>
            {{orderDataDetials?.shippingAddress?.city}},
            {{orderDataDetials?.shippingAddress?.state}},
            {{orderDataDetials?.shippingAddress?.country}},
            {{orderDataDetials?.shippingAddress?.zipCode}}
          </p>
        </div>

        <div class="detail-block">
          <label>Phone</label>
          <p>{{orderDataDetials?.shippingAddress?.countryCode | phoneFormat}} - {{orderDataDetials?.shippingAddress?.mobileNumber | phoneFormat}}</p>
        </div>

        <div class="detail-block">
          <a class="link-inline"
            [href]="'https://www.google.com/maps/@'+orderDataDetials?.shippingAddress?.location?.coordinates[1]+','+orderDataDetials?.shippingAddress?.location?.coordinates[0]+',10z'"
            target="_blank" rel="noopener noreferrer">
            Find location on map
          </a>
        </div>
      </div>
    </article>

    <!-- Payment Details -->
    <article class="order-card payment-card">
      <div class="section-header">
        <p class="section-eyebrow">Payment</p>
        <h2>Transaction Summary</h2>
      </div>

      <ul class="payment-list">
        <li>
          <span>Total Amount</span>
          <strong>{{orderDataDetials?.myOrderPrice && getPrice(orderDataDetials?.myOrderPrice | currency:"ZAR":"R")}}</strong>
        </li>
        <li>
          <span>Payment Mode</span>
          <strong>{{transactionData?.transactionMethod}}</strong>
        </li>
        <li>
          <span>Transaction ID</span>
          <strong>{{transactionData?.trxId}}</strong>
        </li>
      </ul>
    </article>
  </section>
  
    <!-- Order Tracking -->
    <order-tracker [orderDataDetials]="orderDataDetialsTracking"></order-tracker>
    <star-rating *ngIf="feedBackData" [feedBackData]="feedBackData" [isFeedbackDataSubmited]="isFeedbackDataSubmited"
      (submitFeedBack)="submitFeedBack($event)"></star-rating>
  
    <!-- ✅ Return Request Modal -->
    <div class="modal custom-modal-center" id="returnRequestModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered compact-return-modal" role="document"> 
        <div class="modal-content modern-modal-content">
          <div class="modern-modal-header">
            <h5 class="modal-title mb-0">Customer Return Requests</h5>
            <button type="button" class="modern-close-btn" aria-label="Close" (click)="closeReturnRequestPopup()">
              ×
            </button>
          </div>
          <div class="modern-modal-body">
            <div *ngFor="let req of orderDataDetials?.returnRequests; let i = index" class="return-request-card">
              <div class="request-header">
                <span class="request-number">Request #{{i + 1}}</span>
                <span class="request-status" [ngClass]="{
                  'status-pending': req.status == 'PENDING',
                  'status-approved': req.status == 'APPROVED',
                  'status-declined': req.status == 'DECLINED'
                }">{{req.status}}</span>
              </div>
              
              <div class="request-details">
                <div class="detail-row">
                  <span class="detail-label">Request ID:</span>
                  <span class="detail-value">{{req._id}}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Reason:</span>
                  <span class="detail-value">{{req.reason}}</span>
                </div>
                <div class="detail-row" *ngIf="req.additionalInfo">
                  <span class="detail-label">Additional Info:</span>
                  <span class="detail-value">{{req.additionalInfo}}</span>
                </div>
              </div>
  
              <div *ngIf="req.images?.length" class="request-images-section">
                <label class="section-label">Attached Images ({{req.images.length}})</label>
                <div class="request-images-grid">
                  <div *ngFor="let img of req.images" class="request-image-card" (click)="openImageViewer(img)">
                    <img [src]="img" alt="Return image" class="request-image">
                    <div class="image-overlay">
                      <span class="zoom-icon">🔍</span>
                    </div>
                  </div>
                </div>
              </div>
  
              <div *ngIf="req.status == 'PENDING'" class="request-actions">
                <button class="modern-btn modern-btn-success" (click)="updateReturnStatus(orderDataDetials._id, req._id, 'APPROVED')">
                  Accept Request
                </button>
                <button class="modern-btn modern-btn-decline" (click)="updateReturnStatus(orderDataDetials._id, req._id, 'DECLINED')">
                  Decline Request
                </button>
              </div>
            </div>
          </div>
         
            <!-- <button type="button" class="modern-btn modern-btn-secondary" (click)="closeReturnRequestPopup()">
              Close
            </button> -->
          
        </div>
      </div>
    </div>

    <!-- ✅ Image Viewer Modal -->
    <div class="image-viewer-modal" *ngIf="showImageViewer" (click)="closeImageViewer()">
      <div class="image-viewer-container">
        <button type="button" class="image-viewer-close" (click)="closeImageViewer()">
          ×
        </button>
        <div class="image-viewer-content" (click)="$event.stopPropagation()">
          <img [src]="selectedImage" alt="Enlarged view" class="enlarged-image">
        </div>
      </div>
    </div>
  </div>
  
  <otp-modal *ngIf="openModal" [orderId]="_id" (closeModal)="openModal = false"></otp-modal>
  